/**
 * Collection sort dropdown — full page navigation (preserves filters in URL).
 */
(function () {
  const INIT_ATTR = 'data-collection-sort-init';
  const OPEN_CLASS = 'is-open';

  function navigateWithSort(value) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);

    const controller =
      window.CollectionController?.instance || window.CollectionController?.init();

    if (controller) {
      controller.navigate(url.pathname + url.search, {
        updateToolbar: true,
        source: 'sort',
      });
      return;
    }

    window.location.assign(url.toString());
  }

  function closeDropdown(dropdown) {
    const trigger = dropdown.querySelector('[data-collection-sort-trigger]');
    const menu = dropdown.querySelector('[data-collection-sort-menu]');

    dropdown.classList.remove(OPEN_CLASS);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
  }

  function openDropdown(dropdown) {
    const trigger = dropdown.querySelector('[data-collection-sort-trigger]');
    const menu = dropdown.querySelector('[data-collection-sort-menu]');

    dropdown.classList.add(OPEN_CLASS);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    if (menu) menu.hidden = false;
  }

  function setActiveOption(dropdown, optionButton) {
    dropdown.querySelectorAll('[data-collection-sort-option]').forEach((button) => {
      const isActive = button === optionButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const valueEl = dropdown.closest('[data-collection-sort-bar]')?.querySelector('[data-collection-sort-value]');
    if (valueEl) valueEl.textContent = optionButton.textContent.trim();
  }

  function bindCollectionSortDropdown(dropdown) {
    if (dropdown.getAttribute(INIT_ATTR) === 'true') return;
    dropdown.setAttribute(INIT_ATTR, 'true');

    const trigger = dropdown.querySelector('[data-collection-sort-trigger]');
    const menu = dropdown.querySelector('[data-collection-sort-menu]');
    const bar = dropdown.closest('[data-collection-sort-bar]');

    if (!trigger || !menu) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (dropdown.classList.contains(OPEN_CLASS)) {
        closeDropdown(dropdown);
      } else {
        document.querySelectorAll(`[data-collection-sort-dropdown].${OPEN_CLASS}`).forEach((openDropdown) => {
          if (openDropdown !== dropdown) closeDropdown(openDropdown);
        });
        openDropdown(dropdown);
      }
    });

    menu.querySelectorAll('[data-collection-sort-option]').forEach((optionButton) => {
      optionButton.addEventListener('click', (event) => {
        event.preventDefault();

        const value = optionButton.getAttribute('data-value');
        if (!value || optionButton.classList.contains('is-active')) {
          closeDropdown(dropdown);
          return;
        }

        setActiveOption(dropdown, optionButton);
        closeDropdown(dropdown);

        if (bar) bar.classList.add('is-loading');
        navigateWithSort(value);

        if (bar) {
          document.addEventListener(
            'collection-grid-updated',
            () => bar.classList.remove('is-loading'),
            { once: true }
          );
        }
      });
    });
  }

  function bindGlobalCloseHandlers() {
    if (document.documentElement.getAttribute('data-collection-sort-global') === 'true') return;
    document.documentElement.setAttribute('data-collection-sort-global', 'true');

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-collection-sort-dropdown]')) return;

      document.querySelectorAll(`[data-collection-sort-dropdown].${OPEN_CLASS}`).forEach(closeDropdown);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll(`[data-collection-sort-dropdown].${OPEN_CLASS}`).forEach(closeDropdown);
    });
  }

  function initCollectionSort(root = document) {
    bindGlobalCloseHandlers();

    root.querySelectorAll('[data-collection-sort-dropdown]').forEach((dropdown) => {
      bindCollectionSortDropdown(dropdown);
    });
  }

  window.initCollectionSort = initCollectionSort;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionSort());
  } else {
    initCollectionSort();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionSort(event.target);
  });

  document.addEventListener('collection-grid-updated', (event) => {
    initCollectionSort(event.detail?.container || document);
  });
})();
